import { getTalkjsRole, talkjs_app_id } from 'config/Config';
import React, { useEffect, useRef, useState } from 'react';
import ChatCustomHeader from 'v2/Chat/ChatCustomHeader';
import { ProposalEntity, SearchEntity, User } from 'v2/models';
import restFactory from 'v2/utils/restFactory';

interface ProposalTokenChatProps {
  proposal: ProposalEntity;
  userId: number;
  token: string;
}

const ProposalTokenChat = ({
  proposal,
  userId,
  token,
}: ProposalTokenChatProps) => {
  const [user, seUser] = useState<User>();
  const chatContainer = useRef() as React.MutableRefObject<HTMLInputElement>;

  const init = async () => {
    const user = await restFactory.get<User>(
      `/proposals/token/${token}/user/${userId}`
    );

    const chatSession = await createTalkJsSession(user);

    seUser(user);
    setTimeout(() => {
      const inbox = chatSession.createChatbox({
        showChatHeader: false,
        // Type definitions is wrong for Talkjs so here I have to use any type
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } as any);

      if (proposal?.conversation_id) {
        inbox.select(proposal?.conversation_id);
      }

      inbox.mount(chatContainer.current);
    });
  };

  useEffect(() => {
    init();
  }, []);

  if (!user) {
    return null;
  }

  return (
    <div className="redesign h-100">
      <ChatCustomHeader
        key={proposal?.id || 0}
        isDataProvider={!!user.data_provider}
        subject={(proposal.search as SearchEntity).name}
        proposal={proposal}
        user={user}
        showDotsMenu={false}
        hideLeftHeader={true}
      />
      <div className="h-100" ref={chatContainer}></div>
    </div>
  );
};

export default ProposalTokenChat;

async function createTalkJsSession(user: User) {
  return Talk.ready.then(() => {
    const userInfo: UserOptions = {
      id: user.talkjs_id,
      name: user.first_name,
      email: user.email,
      role: getTalkjsRole(),
    };

    if (user.data_provider) {
      const photoUrl = user?.avatar?.formats?.thumbnail?.url;
      if (photoUrl && !user.data_provider.hide_identity_allowed) {
        userInfo.photoUrl = photoUrl;
      }
    }
    const me = new Talk.User(userInfo);
    const talkSession = new Talk.Session({
      appId: talkjs_app_id,
      me: me,
      signature: user.talkjs_signature,
    });

    return talkSession;
  });
}
